import { Component, inject, input } from '@angular/core';
import { ReportDetailedRowDto } from '../../../../../api';
import { CurrencyPipe, DatePipe, NgIf } from '@angular/common';
import { MinutesToHoursPipe } from '../../../../../shared/pipes/minutes-to-hours.pipe';
import { PrimeTemplate } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { RouterLink } from '@angular/router';
import { Tooltip } from 'primeng/tooltip';
import { AuthStore } from '../../../../../auth/services/auth.store';

@Component({
  selector: 'app-detailed-report-table',
  imports: [
    CurrencyPipe,
    MinutesToHoursPipe,
    PrimeTemplate,
    TableModule,
    NgIf,
    RouterLink,
    Tooltip,
  ],
  templateUrl: './detailed-report-table.component.html',
  styleUrl: './detailed-report-table.component.css',
  providers: [DatePipe],
})
export class DetailedReportTableComponent {
  isOwner = input.required<boolean>();
  data = input.required<Array<ReportDetailedRowDto>>();

  constructor(private datePipe: DatePipe) {}

  formatTimeRange(start: Date, end: Date): string {
    const s = this.datePipe.transform(start, 'HH:mm:ss')!;
    const e = this.datePipe.transform(end, 'HH:mm:ss')!;
    return `${s} – ${e}`;
  }

  formatDate(date: Date): string {
    const todayStr = this.datePipe.transform(new Date(), 'dd.MM.yyyy');
    const dateStr = this.datePipe.transform(date, 'dd.MM.yyyy');
    return dateStr === todayStr ? 'Dzisiaj' : dateStr!;
  }
}
